module.exports = __webpack_public_path__ + "img/banner02.459f6a2a.png";